import * as yup from 'yup';

const DetailsFormSchemaTakeaway = yup.object().shape({
  pickupTime: yup.object().typeError('Please select a time').required(),
  name: yup.string().required('Name is required'),
  email: yup.string().trim().email('Must be a valid email').required('Email is required'),
  phone: yup
    .string()
    .matches(new RegExp(/(\d|\s)+/))
    .required(),
});

export default DetailsFormSchemaTakeaway;
